import { createErrors } from '@libs/common-next';

export type Page = 'ProductDetailsPage';

export type Component =
    | 'ProductBaseAPI'
    | 'ProductTailoredAPI'
    | 'AddToCartAPI'
    | 'AutoshipAPI'
    | 'FrequencyCalculator'
    | 'FavoriteAPI'
    | 'RelatedProducts';

/**
 * Errors related to the Product Details Page
 */
export const Errors = createErrors<Page, Component>('ProductDetailsPage')({
    // HIGH SEVERITY - Critical failures that block page load or core functionality
    AddToCartAPI: {
        AddToCartFailed: {
            severity: 'HIGH',
            message: 'Failed to add product to cart',
        },
    },
    AutoshipAPI: {
        AddAutoshipSubscriptionFailed: {
            severity: 'HIGH',
            message: 'Failed to add product to autoship subscription',
        },
        FetchCustomerAutoshipSubscriptionsFailed: {
            severity: 'MEDIUM',
            message: 'Failed to fetch autoship data',
        },
    },
    ProductBaseAPI: {
        FetchProductBaseFailed: {
            severity: 'HIGH',
            message: 'Failed to fetch product base data',
        },
    },
    ProductTailoredAPI: {
        FetchProductTailoredFailed: {
            severity: 'HIGH',
            message: 'Failed to fetch tailored product data',
        },
    },
    FrequencyCalculator: {
        OpenFrequencyCalculatorFailed: {
            severity: 'MEDIUM',
            message: 'Failed to open frequency calculator',
        },
        CalculateFrequencyFailed: {
            severity: 'MEDIUM',
            message: 'Failed to calculate autoship frequency',
        },
        SetAutoshipFrequencyFailed: {
            severity: 'MEDIUM',
            message: 'Failed to set autoship frequency',
        },
        ResetFrequencyCalculatorFailed: {
            severity: 'LOW',
            message: 'Failed to reset frequency calculator',
        },
    },
    // MEDIUM SEVERITY - Errors that may impact user experience but do not block core functionality
    FavoriteAPI: {
        AddFavoriteFailed: {
            severity: 'MEDIUM',
            message: 'Failed to add product to favorites',
        },
        RemoveFavoriteFailed: {
            severity: 'MEDIUM',
            message: 'Failed to remove product from favorites',
        },
    },
    RelatedProducts: {
        FetchRelatedProductsFailed: {
            severity: 'MEDIUM',
            message: 'Failed to fetch related products',
        },
    },
});
